import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addLuaScript } from '../actions/luaAction';

const LuaScriptAddForm = () => {
  const dispatch = useDispatch();
  //const { loading, script, error } = useSelector((state) => state.luaScript);

  const [formData, setFormData] = useState({
    name: '',
    description: '',
    script: '',
  });

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(addLuaScript(formData));
  };

  return (
    <div>
      <h2>Add Lua Script</h2>
      <form onSubmit={handleSubmit}>
        <input name="name" placeholder="Script Name" onChange={handleChange} />
        <input name="description" placeholder="Description" onChange={handleChange} />
        <textarea name="script" placeholder="Lua Code" onChange={handleChange} />
        <button type="submit" //disabled={loading}
        >
          {/* {loading ? 'Saving...' : 'Save Script'} */}
        </button>
      </form>
      {/* {script && <p>✅ Script Added: {script?.data?.name}</p>} */}
      {/* {error && <p style={{ color: 'red' }}>❌ Error: {error}</p>} */}
    </div>
  );
};

export default  LuaScriptAddForm;
